import * as THREE from 'three';

let _pmrmGenerator = null;

export { createPmremGenerator, disposePmremGenerator };

function createPmremGenerator(renderer) {
    if (_pmrmGenerator) return _pmrmGenerator;
    _pmrmGenerator = new THREE.PMREMGenerator(renderer);
    return _pmrmGenerator;
}

function disposePmremGenerator() {
    if (!_pmrmGenerator) return;
    _pmrmGenerator.dispose();
    _pmrmGenerator = null;
}
